import React from "react";
import Sidemenu from "../Sidemenu";
import Centralpart from "./Centralpart";
import Footer from "../Footer";
import { sidemenuFooterWrap } from "../componentCommon";


import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "./Responsive.scss";

let Homepage = sidemenuFooterWrap(Centralpart);

export default Homepage;
